export const DAYS_IN_MONTHS: number[] = [
  31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];
export const DAYS_IN_WEEK: number = 7;
export const EMPTY_ENTRY: string = '\xa0\xa0';
export const MIN_ROW_COUNT: number = 6;
export const WEEKDAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
